import Link from "next/link";
import { PortableTextComponents } from "@portabletext/react";
import { FC } from "react";
import {
  OakLI,
  OakFlex,
  OakTertiaryButton,
  OakVideo,
} from "@oaknational/oak-components";

import { LandingPageOlOutline } from "@/components/GenericPagesComponents/LandingPageOlOutline";
import { TextAndMedia } from "@/common-lib/cms-types";
import { getLinkHref } from "@/utils/portableText/resolveInternalHref";
import Card from "@/components/SharedComponents/Card";
import CMSImage from "@/components/SharedComponents/CMSImage";
import BrushBorders from "@/components/SharedComponents/SpriteSheet/BrushSvgs/BrushBorders";
import { PortableTextWithDefaults } from "@/components/SharedComponents/PortableText";
import VideoPlayer from "@/components/SharedComponents/VideoPlayer";

const landingPortableTextComponent: PortableTextComponents = {
  list: {
    number: ({ children }) => (
      <LandingPageOlOutline $textColor="oakGreen" $mh="spacing-0">
        {children}
      </LandingPageOlOutline>
    ),
  },

  listItem: {
    number: (props) => {
      const listItemText = props?.value?.children[0]?.text;

      return (
        <OakFlex $position={"relative"} $mb="spacing-48" $alignItems={"center"}>
          <OakLI $color={"text-primary"} $font={["heading-7", "heading-6"]}>
            {listItemText}
          </OakLI>
        </OakFlex>
      );
    },
  },
};

export const LandingPageTextAndMedia: FC<TextAndMedia> = (props) => {
  return (
    <Card
      $flexDirection={["column", "row"]}
      $background={"bg-decorative5-subdued"}
      $width={"100%"}
      $mb={["spacing-56", "spacing-80"]}
      $pb={"spacing-24"}
      $ph={["spacing-16", "spacing-56"]}
    >
      <BrushBorders $hideOnMobileH color={"bg-decorative5-subdued"} />
      <OakFlex
        $minHeight={"spacing-240"}
        $position="relative"
        $minWidth={["100%", "50%"]}
        $mb={["spacing-48", "spacing-0"]}
      >
        {props.mediaType == "image" && (
          <CMSImage
            $pr={[0, 24, 72]}
            alt={props.image.altText || ""}
            $objectFit="contain"
            $objectPosition={"center"}
            fill
            priority
            image={props.image}
          />
        )}
        {props.mediaType == "video" && (
          <OakFlex $alignItems={"center"} $ph="spacing-20">
            <OakVideo
              videoSlot={
                <VideoPlayer
                  playbackPolicy="public"
                  playbackId={props.video.video.asset.playbackId}
                  thumbnailTime={props.video.video.asset.thumbTime}
                  title={props.video.title}
                  location="marketing"
                  omitBorder={true}
                />
              }
              showTranscript={true}
              transcript={props.video.transcript}
            />
          </OakFlex>
        )}
      </OakFlex>
      <OakFlex
        $minWidth={["100%", "50%"]}
        $justifyContent={"center"}
        $flexDirection={"column"}
      >
        <PortableTextWithDefaults
          components={landingPortableTextComponent}
          value={props.bodyPortableText}
        />
        <div>
          {props.cta && (
            <OakTertiaryButton
              $mt={["spacing-48", "spacing-32"]}
              element={Link}
              iconName="arrow-right"
              isTrailingIcon
              href={getLinkHref(props.cta)}
            >
              {props.cta.label}
            </OakTertiaryButton>
          )}
        </div>
      </OakFlex>
    </Card>
  );
};
